/**
 * 双 rAF 近似绘制时刻（相对 navigationStart 的 performance.now）
 *
 * @description
 * 作 fp/fcp 缺失时的参考指标；iOS 13 等无 Paint Timing 时仍可上报。
 */

import { getNavElapsedMs } from '../loading-timing';

/**
 * 在下一帧绘制后回调，返回 navigation 起点至双 rAF 的耗时（ms）
 */
export function measureNavOriginRafPaintMs(onMeasured: (rafPaintMs: number) => void): void {
    if (typeof window === 'undefined' || typeof requestAnimationFrame !== 'function') {
        onMeasured(Math.round(getNavElapsedMs()));
        return;
    }

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            onMeasured(Math.round(getNavElapsedMs()));
        });
    });
}
